import * as React from 'react';
import { observer } from 'mobx-react';
import * as IChangeDataPopUpParams from './IChangeDataPopUpParams';
import { ISingleMeasurementParameter } from 'Data';
import { BaseReportHelpers } from 'Reports';

export interface IChangeDataPopUpState {
  measurementParameters: Array<ISingleMeasurementParameter>;
}

@observer
export class ChangeDataPopUp extends React.Component<
  IChangeDataPopUpParams.IChangeDataPopUpParams,
  IChangeDataPopUpState
> {
  private tilesToSwap: Array<any>;

  constructor(props: IChangeDataPopUpParams.IChangeDataPopUpParams) {
    super(props, undefined);
    this.tilesToSwap = [];
    this.state = { ...this.state, ...{ measurementParameters: props.measurementParameters } };
    this.visibilityOfParameter = this.visibilityOfParameter.bind(this);
    this.disableTile = this.disableTile.bind(this);
  }

  disableTile(propertyName: string) {
    // Find the actual index in the full measurementParameters array
    const parameterToRemove = this.state.measurementParameters?.findIndex(
      x => x.propertyName === propertyName
    );
    if (parameterToRemove !== -1) {
      this.props.disableTile(parameterToRemove);
    }
  }

  visibilityOfParameter(index: number, isAddTile?: boolean) {
    let parameterToAdd;

    if (isAddTile) {
      parameterToAdd = {
        propertyName: '',
        title: '',
        myTrackManPage: '',
        isVisible: true,
        displayUnit: '',
      };
      (parameterToAdd as any)['isSelected'] = false;
    } else {
      parameterToAdd = this.state.measurementParameters[index];
    }

    parameterToAdd['isSelected'] = true;

    if (this.tilesToSwap.length === 0) {
      this.tilesToSwap.push(parameterToAdd);
    } else if (this.tilesToSwap.length === 1) {
      if (this.tilesToSwap[0].isVisible === parameterToAdd.isVisible) {
        if (this.tilesToSwap[0].propertyName === parameterToAdd.propertyName) {
          this.tilesToSwap[0]['isSelected'] = false;
          this.tilesToSwap = [];
        } else if (this.tilesToSwap[0].isVisible) {
          this.tilesToSwap.push(parameterToAdd);
        } else {
          this.tilesToSwap[0]['isSelected'] = false;
          this.tilesToSwap[0] = parameterToAdd;
          this.tilesToSwap[0]['isSelected'] = true;
        }
      } else {
        this.tilesToSwap.push(parameterToAdd);
      }
    }

    if (this.tilesToSwap.length === 2) {
      //Swapping
      const indexOfFirstTile = this.state.measurementParameters.indexOf(this.tilesToSwap[0]);
      const indexOfSecondTile = this.state.measurementParameters.indexOf(this.tilesToSwap[1]);
      //If plus button clicked
      if (indexOfFirstTile === -1 || indexOfSecondTile === -1) {
        if (
          indexOfFirstTile === -1 &&
          !this.state.measurementParameters[indexOfSecondTile].isVisible
        ) {
          const newState = this.state.measurementParameters;
          newState[indexOfSecondTile].isVisible = !this.state.measurementParameters[
            indexOfSecondTile
          ].isVisible;
          //this.state.measurementParameters[indexOfSecondTile].isVisible = !this.state.measurementParameters[indexOfSecondTile].isVisible;
          this.setState({ measurementParameters: newState });
          this.state.measurementParameters.splice(indexOfSecondTile, 1);
          this.state.measurementParameters.splice(
            this.state.measurementParameters.filter(x => {
              return x.isVisible;
            }).length,
            0,
            this.tilesToSwap[1]
          );
        } else if (
          indexOfSecondTile === -1 &&
          !this.state.measurementParameters[indexOfFirstTile].isVisible
        ) {
          const newState = this.state.measurementParameters;
          newState[indexOfFirstTile].isVisible = !this.state.measurementParameters[indexOfFirstTile]
            .isVisible;
          //this.state.measurementParameters[indexOfFirstTile].isVisible = !this.state.measurementParameters[indexOfFirstTile].isVisible;
          this.setState({ measurementParameters: newState });
          this.state.measurementParameters.splice(indexOfFirstTile, 1);
          this.state.measurementParameters.splice(
            this.state.measurementParameters.filter(x => {
              return x.isVisible;
            }).length,
            0,
            this.tilesToSwap[0]
          );
        }
        this.tilesToSwap[0]['isSelected'] = false;
        this.tilesToSwap[1]['isSelected'] = false;
        this.tilesToSwap = [];
      } else {
        if (!this.tilesToSwap?.[0]?.isVisible || !this.tilesToSwap?.[1]?.isVisible) {
          const newState = this.state.measurementParameters;
          newState[indexOfFirstTile].isVisible = !this.state.measurementParameters[indexOfFirstTile]
            .isVisible;
          newState[indexOfSecondTile].isVisible = !this.state.measurementParameters[
            indexOfSecondTile
          ].isVisible;
          //this.state.measurementParameters[indexOfFirstTile].isVisible = !this.state.measurementParameters[indexOfFirstTile].isVisible;
          //this.state.measurementParameters[indexOfSecondTile].isVisible = !this.state.measurementParameters[indexOfSecondTile].isVisible;
          this.setState({ measurementParameters: newState });
        }

        if (indexOfSecondTile > indexOfFirstTile) {
          //Remove this.tilesToSwap[0]
          this.state.measurementParameters.splice(indexOfFirstTile, 1);

          //Insert this.tilesToSwap[0]
          this.state.measurementParameters.splice(indexOfSecondTile, 0, this.tilesToSwap[0]);

          //Insert this.tilesToSwap[1]
          this.state.measurementParameters.splice(indexOfFirstTile, 0, this.tilesToSwap[1]);

          //Remove this.tilesToSwap[1]
          this.state.measurementParameters.splice(indexOfSecondTile, 1);
        }

        if (indexOfFirstTile > indexOfSecondTile) {
          //Insert this.tilesToSwap[1]
          this.state.measurementParameters.splice(indexOfFirstTile, 0, this.tilesToSwap[1]);
          //Remove this.tilesToSwap[1]
          this.state.measurementParameters.splice(indexOfSecondTile, 1);
          //Remove this.tilesToSwap[0]
          this.state.measurementParameters.splice(indexOfFirstTile, 1);
          //Insert this.tilesToSwap[0]
          this.state.measurementParameters.splice(indexOfSecondTile, 0, this.tilesToSwap[0]);
        }
        this.tilesToSwap[0]['isSelected'] = false;
        this.tilesToSwap[1]['isSelected'] = false;
        this.tilesToSwap = [];
      }
    }

    this.setState(() => {
      return { measurementParameters: this.state.measurementParameters };
    });
    const newTilesToDisplay = this.state.measurementParameters
      .filter(parameter => parameter.isVisible)
      .map(x => x.propertyName);
    BaseReportHelpers.changeTilesToDisplay(newTilesToDisplay, this.props.reportStore);
  }

  render() {
    return (
      <tr className="ChangeDataPopUp hidden-print" style={{ borderColor: this.props.color }}>
        <span className="close-change-data-information-wrapper">
          <span
            className="close-change-data-information"
            onClick={() => {
              this.props.changeDataOptions();
            }}
          >
            <img className="" src="Images/MultiShotControl/close-icon.svg" alt="close icon" />
          </span>
        </span>
        <td
          className="change-data"
          onClick={() => {
            this.props.changeDataOptions();
          }}
        >
          <span data-toggle="modal">Change Data</span>
          <img
            className="change-data-icon"
            src="Images/MultiShotControl/change-data-icon.svg"
            alt="change data icon"
          />
          <span className="horizontal-line" style={{ borderBottomColor: this.props.color }}></span>
        </td>
        <td className="tile-wrapper" style={{ padding: 0 }}>
          <span className="box-with-chosen-parameter-tiles">
            {this.state.measurementParameters
              .filter(x => x.isVisible)
              .map((param, i) => {
                return (
                  <span className="parameter-tile-wrapper" key={param.propertyName}>
                    <span
                      className={
                        'parameter-tile ' +
                        `${param['isSelected'] === true ? 'selected-visible-tile' : ''}`
                      }
                      onClick={() => this.visibilityOfParameter(i)}
                    >
                      <span className="parameter-name">{param.title}</span>
                      <span className="horizontal-line"></span>
                      <span className="parameter-unit">{param.displayUnit}</span>
                    </span>
                    {this.props.reportStore.tilesToDisplay.length !== 1 && (
                      <span
                        className="remove-tile"
                        onClick={() => this.disableTile(param.propertyName)}
                      >
                        <img
                          className="minus-icon"
                          src="Images/MultiShotControl/line.svg"
                          alt="line"
                        />
                      </span>
                    )}{' '}
                  </span>
                );
              })}
            {this.state.measurementParameters.map((param, i) => {
              if (
                i <=
                10 -
                  (this.state.measurementParameters.filter(x => {
                    return x.isVisible;
                  }).length +
                    1)
              ) {
                if (i === 0) {
                  return (
                    <span
                      className="parameter-tile-wrapper"
                      key={param.propertyName}
                      onClick={() =>
                        this.visibilityOfParameter(
                          this.state.measurementParameters.filter(x => {
                            return x.isVisible;
                          }).length,
                          true
                        )
                      }
                    >
                      <span className="parameter-tile plus">
                        <img
                          className="plus-icon"
                          src="Images/MultiShotControl/plus.svg"
                          alt="plus"
                        />
                      </span>
                    </span>
                  );
                }
                if (i !== 0) {
                  return (
                    <span className="parameter-tile-wrapper" key={param.propertyName}>
                      <span className="parameter-tile empty"></span>
                    </span>
                  );
                }
              }
              return null;
            })}
          </span>
          <span className="text-for-change-data">Click two tiles to change their place</span>
          <span className="box-with-not-chosen-parameter-tiles">
            {this.state.measurementParameters.map((param, i) => {
              if (param.isVisible === false) {
                return (
                  <span className="parameter-tile-wrapper" key={param.propertyName}>
                    <span
                      className={`parameter-tile not-selected ${
                        param['isSelected'] === true ? 'selected-invisible-tile' : ''
                      }`}
                      onClick={() => this.visibilityOfParameter(i)}
                    >
                      <span className="parameter-name" data-bind="text: title">
                        {param.title}
                      </span>
                      <span className="horizontal-line"></span>
                      <span className="parameter-unit" data-bind="text: displayUnit">
                        {param.displayUnit}
                      </span>
                    </span>
                  </span>
                );
              }
              return null;
            })}
          </span>
        </td>
      </tr>
    );
  }
}
